var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGifMakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "loader_spiner",
    viewBox: "0 0 176 160",
    width: "176px",
    height: "160px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pl-grad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "hsl(205, 100%, 90%)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "hsl(205, 100%, 90%)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "hsl(205, 100%, 90%)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 16,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "pl__ring",
    r: 56,
    cx: 88,
    cy: 96,
    stroke: "hsla(0,10%,10%,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pl__worm1",
    d: "M144,96A56,56,0,0,1,32,96",
    stroke: "url(#pl-grad)",
    strokeDasharray: "43.98 307.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pl__worm2",
    d: "M32,136V96s-.275-25.725,14-40",
    stroke: "hsl(0, 100%, 90%)",
    strokeDasharray: "0 40 0 44",
    strokeDashoffset: 0.001,
    visibility: "hidden"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pl__worm3",
    d: "M144,136V96s.275-25.725-14-40",
    stroke: "hsl(138, 53%, 82%)",
    strokeDasharray: "0 40 0 44",
    strokeDashoffset: 0.001,
    visibility: "hidden"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifMakao);
export default __webpack_public_path__ + "static/media/gifMakao.b0803244cec9a0bca74411c41c7b841c.svg";
export { ForwardRef as ReactComponent };